import WrapperProvider from "@providers/WrapperProvider";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import ArticleContainer from "@containers/ArticleContainer";
import _ from "lodash";
import { getServer } from "@translations/next";
import StoryArticleService from "@services/StoryArticleService";
import Layout from "@components/Layout";
import helper from "@utils/helper";
import FooterService from "@services/FooterService";
export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout config={{ zaloShare: true }}>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <ArticleContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  const slug = _.get(params, "slug");
  const resArticles = await StoryArticleService.find({
    filters: {
      slug: {
        $ne: slug,
      },
      hotels: {
        slug: {
          $eq: "amanaki-thao-dien",
        },
      },
    },
    locale,
    page: 1,
    pageSize: 3,
    populate: ["category", "thumbnail"],
    sort: 'publishedAt:desc',
  });
  const resArticle = await StoryArticleService.find({
    filters: {
      slug: {
        $eq: slug,
      },
      hotels: {
        slug: {
          $eq: "amanaki-thao-dien",
        },
      },
    },
    populate: [
      "category",
      "thumbnail",
      "details",
      "details.images",
      "details.image",
      "metatags",
      "metatags.image",
    ],
    locale,
  });
  const defaultMetatags = {
    title: _.get(resArticle, "data.0.attributes.title", ""),
    description: _.get(resArticle, "data.0.attributes.description", ""),
    image: _.get(resArticle, "data.0.attributes.thumbnail", {}),
    tags: _.get(resArticle, "data.0.attributes.tags", ""),
  };
  const footerData = await FooterService.fetchByHotel("amanaki-thao-dien", locale);
  const result: any = {
    hotel: "amanaki-thao-dien",
    articles: _.get(resArticles, "data", []),
    article: _.get(resArticle, "data.0", null),
    pageData: {
      metatags: _.get(resArticle, "data.0.attributes.metatags") || defaultMetatags,
    },
    footerData,
  };
  if (_.isEmpty(_.get(resArticle, "data.0"))) {
    // TODO: check with none locale.
    const resArticleNoneLocale = await StoryArticleService.find({
      filters: {
        slug: {
          $eq: slug,
        },
        hotels: {
          slug: {
            $eq: "amanaki-thao-dien",
          },
        },
      },
      populate: "deep",
      locale: "all",
    });
    if (_.isEmpty(_.get(resArticleNoneLocale, "data.0"))) {
      result.notFound = true;
    } else {
      const destination = helper.resolveArticleRedirectDestination(
        _.get(resArticleNoneLocale, "data.0"),
        locale,
        "amanaki-thao-dien",
        slug as string
      );
      if (destination) {
        result.redirect = {
          destination,
          permanent: false,
        };
      } else {
        result.notFound = true;
      }
    }
  }
  return result;
});
